export enum BookingDayLengthType {
	Full = 1,
	Half = 2,
	Mixed = 3,
}

export enum BookingDayLengthAmPm {
	AM = "AM",
	PM = "PM",
}
